import React, { useState } from "react";
import NavbarHome from "../ui/NavbarHome";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";

export default function Login() {
  const { register, handleSubmit } = useForm();
  const [data, setData] = useState("");
  const navigate = useNavigate();
  const onSubmit = (val) => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(val),
    };

    fetch("https://scopex.cloud/api/track", requestOptions)
      .then((response) => {
        if (response.ok) {
          navigate("/Dashboard");
        } else {
          if (response.status === 400) {
            console.log("imgettingerror");
          }
        }
      })
      .then((result) => {
        if (result?.status === "true") {
          setData(val);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div>
        <NavbarHome />
        <div className="min-h-full relative flex items-center justify-center sm:mt-24 mt-8 sm:px-6 lg:px-8">
          <div className="max-w-xl w-full bg-white p-4 shadow-lg rounded-xl border-2 space-y-8 sm:mx-0 mx-6">
            <div>
              <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                Track Transfer
              </h2>
            </div>
            <input type="hidden" name="remember" value="true" />
            <div className="rounded-md shadow-sm space-y-4">
              <div>
                <label htmlFor="username" className="font-light">
                  Tracking ID
                </label>
                <input
                  {...register("username")}
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                  placeholder="Enter your transaction id here."
                />
              </div>
            </div>
            <div className="mb-28">
              <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white"
                style={{ backgroundColor: "#5C6E64" }}
              >
                Check Status
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
